import React from "react";

const DiscardedSmall = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3578_8)">
      <rect x="4" y="4" width="16" height="16" rx="2" fill="#FFE4E6" />
    </g>
    <path
      d="M12.704 12.002L14.854 9.85705C14.9481 9.76289 15.001 9.6352 15.001 9.50205C15.001 9.3689 14.9481 9.2412 14.854 9.14705C14.7598 9.05289 14.6321 9 14.499 9C14.3658 9 14.2381 9.05289 14.144 9.14705L11.999 11.297L9.85399 9.14705C9.75984 9.05289 9.63214 9 9.49899 9C9.36584 9 9.23814 9.05289 9.14399 9.14705C9.04984 9.2412 8.99695 9.3689 8.99695 9.50205C8.99695 9.6352 9.04984 9.76289 9.14399 9.85705L11.294 12.002L9.14399 14.147C9.09713 14.1935 9.05993 14.2488 9.03455 14.3098C9.00916 14.3707 8.99609 14.436 8.99609 14.502C8.99609 14.5681 9.00916 14.6334 9.03455 14.6943C9.05993 14.7553 9.09713 14.8106 9.14399 14.857C9.19047 14.9039 9.24577 14.9411 9.3067 14.9665C9.36763 14.9919 9.43299 15.0049 9.49899 15.0049C9.565 15.0049 9.63035 14.9919 9.69128 14.9665C9.75221 14.9411 9.80751 14.9039 9.85399 14.857L11.999 12.707L14.144 14.857C14.1905 14.9039 14.2458 14.9411 14.3067 14.9665C14.3676 14.9919 14.433 15.0049 14.499 15.0049C14.565 15.0049 14.6304 14.9919 14.6913 14.9665C14.7522 14.9411 14.8075 14.9039 14.854 14.857C14.9009 14.8106 14.9381 14.7553 14.9634 14.6943C14.9888 14.6334 15.0019 14.5681 15.0019 14.502C15.0019 14.436 14.9888 14.3707 14.9634 14.3098C14.9381 14.2488 14.9009 14.1935 14.854 14.147L12.704 12.002Z"
      fill="#961B01"
    />
    <defs>
      <filter
        id="filter0_d_3578_8"
        x="0"
        y="0"
        width="24"
        height="24"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3578_8"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3578_8"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default DiscardedSmall;
